// ----------------------------------------------------------------------

import { httpClient } from '@/shared/lib/axios';

import type { PaginatedList, PaginationParams } from '../types/pagination.types';
import type { IkpuInfo } from './search.types';

export type IkpusParams = PaginationParams & {
  query?: string;
};

export type IkpuParams = PaginationParams & {
  ikpu: string;
};
// ----------------------------------------------------------------------

export const SearchApi = {
  fetchIkpusInfo: async (params?: IkpusParams) => {
    const { data } = await httpClient.get<PaginatedList<'items', IkpuInfo>>('nomenclature/search', { params });

    return data;
  },

  fetchIkpuInfo: async (params: IkpuParams) => {
    const { ikpu } = params;

    const { data } = await httpClient.get<PaginatedList<'items', IkpuInfo>>(`nomenclature/search/${ikpu}`);

    return data;
  },
};
